module.exports = __webpack_public_path__ + "static/img/backtop.7764da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/top-vedio/backtop.png
// module id = 0yVQ
// module chunks = 1